'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var immutable = require('immutable');
var nativeTypeHelpers = require('./helpers/native-type-helpers');

function serialize(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (immutable.Iterable.isIterable(data) || data instanceof immutable.Record || nativeTypeHelpers.isSupportedNativeType(data)) {
    var patchedData = Object.create(data);

    if (nativeTypeHelpers.isSupportedNativeType(data)) {
      // NOTE: When native type (such as Date or RegExp) methods are called
      //   on an `Object.create()`'d objects, invalid usage errors are thrown
      //   in many cases. We need to patch the used methods to work
      //   on originals.
      nativeTypeHelpers.patchNativeTypeMethods(patchedData, data);
    }

    // NOTE: JSON.stringify() calls the #toJSON() method of the root object.
    //   Immutable.JS provides its own #toJSON() implementation which does not
    //   preserve map key types.
    patchedData.toJSON = function () {
      return this;
    };

    data = patchedData;
  }

  var indentation = options.pretty ? 2 : 0;

  return JSON.stringify(data, replace.bind(this, options), indentation);
}

function replace(options, key, value) {
  var result = value;
  var replaceBind = replace.bind(this, options);

  if (value instanceof immutable.Record) {
    result = replaceRecord(value, options, replaceBind);
  } else if (immutable.Iterable.isIterable(value)) {
    result = replaceIterable(value, replaceBind);
  } else if (Array.isArray(value)) {
    result = replaceArray(value, replaceBind);
  } else if (nativeTypeHelpers.isDate(value)) {
    result = { '__date': value.toISOString() };
  } else if (nativeTypeHelpers.isRegExp(value)) {
    result = { '__regexp': value.toString() };
  } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
    result = replacePlainObject(value, replaceBind);
  }

  return result;
}

function replaceRecord(rec, options, replaceChild) {
  var recordDataMap = rec.toMap();
  var recordData = {};

  recordDataMap.forEach(function (value, key) {
    recordData[key] = replaceChild(key, value);
  });

  var name = rec._name;
  if (!rec._name) {

    if (options.storeUnknownRecords) {
      name = '__unknown';
    } else {
      return recordData;
    }
  }
  return { "__record": name, "data": recordData };
}

function replaceIterable(iter, replaceChild) {

  var iterableType = iter.constructor.name;

  var _ret = function () {
    switch (iterableType) {
      case 'List':
      case 'Set':
      case 'OrderedSet':
      case 'Stack':
        var listData = [];
        iter.forEach(function (value, key) {
          listData.push(replaceChild(key, value));
        });
        return {
          v: { "__iterable": iterableType, "data": listData }
        };

      case 'Map':
      case 'OrderedMap':
        var mapData = [];
        iter.forEach(function (value, key) {
          mapData.push([key, replaceChild(key, value)]);
        });
        return {
          v: { "__iterable": iterableType, "data": mapData }
        };

      default:
        var iterData = {};
        iter.forEach(function (value, key) {
          iterData[key] = replaceChild(key, value);
        });
        return {
          v: { "__iterable": iterableType, "data": iterData }
        };
    }
  }();

  if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
}

function replaceArray(arr, replaceChild) {

  return arr.map(function (value, index) {
    return replaceChild(index, value);
  });
}

function replacePlainObject(obj, replaceChild) {

  var objData = {};
  Object.keys(obj).forEach(function (key) {
    objData[key] = replaceChild(key, obj[key]);
  });

  return objData;
}

module.exports = {
  serialize: serialize
};


//////////////////
// WEBPACK FOOTER
// ./~/json-immutable-ex/lib/serialize.js
// module id = 985
// module chunks = 0